import React, { createContext, useCallback, useContext, useState } from 'react';
import { SettingsDialog, type SettingsTabKey } from '@/features/settings';

interface SettingsDialogContextValue {
  openSettings: (tab?: SettingsTabKey) => void;
}

const SettingsDialogContext = createContext<SettingsDialogContextValue | null>(null);

export function SettingsDialogProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const [initialTab, setInitialTab] = useState<SettingsTabKey>('appearance');

  const openSettings = useCallback((tab: SettingsTabKey = 'appearance') => {
    setInitialTab(tab);
    setOpen(true);
  }, []);

  return (
    <SettingsDialogContext.Provider value={{ openSettings }}>
      {children}
      <SettingsDialog open={open} onOpenChange={setOpen} initialTab={initialTab} />
    </SettingsDialogContext.Provider>
  );
}

export function useSettingsDialog() {
  const ctx = useContext(SettingsDialogContext);
  if (!ctx) {
    throw new Error('useSettingsDialog must be used within SettingsDialogProvider');
  }
  return ctx;
}
